import { ValidatorRules } from '../../../tradebuilder-v2/util/validator'
import { EditCashInstrumentsState } from '../edit-cash-instruments-slice'

export const editCashInstrumentRules: ValidatorRules<EditCashInstrumentsState> = {
  instrument_name: [
    (state: EditCashInstrumentsState) => ({
      isValid: state.selectedInstrument.name.length > 0,
      message: 'Instrument must have a name'
    })
  ],
  id: [
    (state: EditCashInstrumentsState) => ({
      isValid: state.selectedInstrument.instrumentId.length === 12 || !state.isNew,
      message: 'Instrument must have an Id containing 12 characters'
    })
  ]
}
